import React from 'react';

export const SelectedRawWordsContext = React.createContext({
  selectedWords: [],
  addWord: (word) => { },
  removeWord: (word) => { },
  isWordSelected: (word) => { },
  clearWords: () => { },
  clearAndAddWord: () => {}
});